<template>
    <div class="home">
        <Head-view></Head-view>
        <div class="main">
            <div class="initializationPage">
                <div class="banner"></div>
                <div class="icoSum">
                    <div
                        class="dataBox"
                        v-for="(item, key) in dataCar"
                        :key="key"
                        :class="[item.marginLeft ? 'marginLeft' : '']"
                    >
                        <div class="dataIco" :class="[item.style]"></div>
                        <div class="dataNum">
                            <div class="dataExplain">
                                <span class="dataFont">{{ item.font }}</span
                                ><br />
                                <span class="num">{{ item.num }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { getCookie } from "../../untils/tools";
import HeadView from "@/components/HeadView";

export default {
    name: "Home",
    components: {
        HeadView,
    },
    data() {
        return {
            dataCar: [
                {
                    marginLeft: false,
                    style: "dataInst",
                    font: "机构数",
                    id: "insCount",
                    num: "0",
                },
                {
                    marginLeft: true,
                    style: "dataRout",
                    font: "路线数",
                    id: "routeCount",
                    num: "0",
                },
                {
                    marginLeft: true,
                    style: "dataTask",
                    font: "任务数",
                    id: "taskCount",
                    num: "0",
                },
                {
                    marginLeft: true,
                    style: "dataPosi",
                    font: "点位数",
                    id: "placeCount",
                    num: "0",
                },
                {
                    marginLeft: true,
                    style: "dataPeop",
                    font: "人员数",
                    id: "staffCount",
                    num: "0",
                },
                {
                    marginLeft: true,
                    style: "dataWarn",
                    font: "故障数",
                    id: "faultCount",
                    num: "0",
                },
            ],
        };
    },

    created() {},

    mounted() {
        this.getStatisticsInit();
    },

    methods: {
        goOut() {
            if (!getCookie()) {
                this.$message({
                    type: "warning",
                    message: "登录过期，请重新登录！",
                });
                //
                return setTimeout(() => {
                    this.$message.closeAll();
                    this.$router.replace("/login");
                }, 1000);
            }
            this.getStatisticsInit()
        },

        getStatisticsInit() {
            let data = {
                token: getCookie()
            }
            this.request.post(this.baseUrl + 'institution/getStatistics', data).then(res => {
                if (res.code == 0) {
                    this.dataCar.forEach((item, key) => {
                        for (let val in res.data) {
                            if (item.id == val) {
                                this.dataCar[key]['num'] = res.data[val]
                            }
                        }
                    })
                }
            }).catch(err => {
                this.$message({
                    type: 'error',
                    message: err
                })
            })
        }
    },
};
</script>

<style lang="less" scoped>
.home {
    width: 100%;
    height: 100vh;
    
    .main {
        padding: 80px 0 0 234px;

        .initializationPage {
            margin-right: 24px;

            .banner {
                width: 100%;
                height: 651px;
                background: url("../../assets/home/home.png") no-repeat 0 0;
                background-size: 100% 100%;
            }

            .icoSum {
                margin-top: 26px;
                display: flex;
                flex-direction: row;
                width: 100%;
                .dataBox {
                    width: 16.6%;
                    height: 119px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 8px;
                }
            }
        }
    }
}

.dataBox {
    display: flex;
    flex-direction: row;
    .dataIco {
        width: 39%;
        height: 119px;
    }
    .dataNum {
        width: 61%;
        height: 119px;
        .dataExplain {
            margin-left: 20px;
            margin-top: 27px;
            .dataFont {
                color: rgba(128, 128, 128, 1);
                font-size: 16px;
                font-weight: 400;
            }

            .num {
                color: rgba(0, 0, 0, 1);
                font-size: 24px;
                font-weight: 700;
                line-height: 50px;
            }
        }
    }

    .dataInst {
        background: url("../../assets/home/icoInstitution.png") no-repeat center
            center;
        background-size: 54px 54px;
    }

    .dataPosi {
        background: url("../../assets/home/icoPosition.png") no-repeat center
            center;
        background-size: 54px 54px;
    }

    .dataPeop {
        background: url("../../assets/home/icoPeople.png") no-repeat center
            center;
        background-size: 54px 54px;
    }

    .dataWarn {
        background: url("../../assets/home/icoWarning.png") no-repeat center
            center;
        background-size: 54px 54px;
    }

    .dataRout {
        background: url("../../assets/home/icoRoute.png") no-repeat center
            center;
        background-size: 54px 54px;
    }

    .dataTask {
        background: url("../../assets/home/icoTask.png") no-repeat center center;
        background-size: 54px 54px;
    }
}

.marginLeft {
    margin-left: 17px;
}
</style>
